const download = () => import("@/views/download/download.vue");
const sellerDownload = () => import("@/views/download/sellerDownload.vue");

export default [
	{
		path: '/download', // 下载
		name: 'download',
		component: download,
		meta: {
			title: '下载',
			keepAlive: false
		}
	},
	{
		path: '/sellerDownload', // 下载
		name: 'sellerDownload',
		component: sellerDownload,
		meta: {
			title: '下载',
			keepAlive: false
		}
	},
]